export const successNotification = (text = 'Saved successfully') => ({
  type: 'success',
  text: `
    <svg class="i success-tick"><use xlink:href="/sprites.svg#tick"></use></svg>
    <span>${text}</span>
  `,
})

export const errorNotification = (text = 'Error') => ({
  type: 'error',
  text: `
    <svg class="i error-tick"><use xlink:href="/sprites.svg#close"></use></svg>
    <span>${text}</span>
  `,
})

export const infoNotification = (text = 'Info') => ({
  type: 'info',
  text: `
    <svg class="i info-notification-tick"><use xlink:href="/sprites.svg#info"></use></svg>
    <span>${text}</span>
  `,
})

export const warningNotification = (text = 'Warning') => ({
  type: 'warning',
  text: `
    <svg class="i warning-tick"><use xlink:href="/sprites.svg#warning"></use></svg>
    <span>${text}</span>
  `,
})
